import React from 'react';
// import _ from 'lodash';
import './InteractiveSliders.css'


/**
 * 
 * default values: n, t, d, k_off
 * inputs: [{key: 'N', rangeLimit: {min: 0, max: 100}, type: 'int'|'float', }]
 */
function ParameterSlidersLog(props) {
    const [parameters, setParameters] = React.useState(
        props.defaultValues
    );

    const [graphParameters, setGraphParameters] = React.useState(
        props.defaultValues
    );

    const handleKeyDown = (event, newParams) => {
        if (event.key === 'Enter') {
        console.log('keydown')
            setGraphParameters(newParams)
        }
      }
console.log(graphParameters)
    const onParameterChange = React.useCallback((key, value) => {
        setParameters({...parameters, [key]: value})
    }, [setParameters, parameters])

  return (
    <div>
    <div className="parameter-sliders">
        {props.inputs.map((parameter) => (
            <div class="filter_line">
                <label>{parameter.key}:</label>
                <input type="number"
                    value={parseFloat(parameters[parameter.key]).toExponential(2)}
                    onInput={(e) => onParameterChange(parameter.key, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, {...parameters, [parameter.key]: e.target.value})}
                    />
                <input id="zValue" class="slider" type="range" 
                    min={Math.log10(parameter.rangeLimit.min)} 
                    max={Math.log10(parameter.rangeLimit.max)} 
                    step={(Math.log10(parameter.rangeLimit.max) - Math.log10(parameter.rangeLimit.min))/100} 
                    value={Math.log10(parameters[parameter.key])}
                    onChange={(e) => {
                        const newValue = Math.pow(10, e.target.value);
                        onParameterChange(parameter.key, newValue);
                      }}
                      onMouseUp={(e) => {
                        const newValue = Math.pow(10, e.target.value);
                        setGraphParameters({ ...parameters, [parameter.key]: newValue });
                      }}
                    />
            </div>
        ))}
    </div>
    {props.graphComponent && <props.graphComponent {...graphParameters}/>}
    </div>
  );
}

export default ParameterSlidersLog;